var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-block-editor wait-for" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.waitForWaitForWhat"))),
        ]),
        _vm._v(" "),
        _c("CustomPicker", {
          attrs: {
            items: _vm.waitForTypes,
            idKey: "id",
            labelKey: "label",
            title: "Select Wait For What",
          },
          model: {
            value: _vm.clone.mode,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "mode", $$v)
            },
            expression: "clone.mode",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
      _c("div", { staticClass: "editor-row-title" }, [
        _vm._v(_vm._s(_vm.$t("auto.waitForHowLongToWait"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btnGroup" },
        _vm._l(["static", "dynamic"], function (mode) {
          return _c(
            "SupsisButton",
            {
              key: mode,
              attrs: {
                classNames:
                  _vm.clone.endDate.mode === mode
                    ? "btnGroupItem selected"
                    : "btnGroupItem ",
                primary: _vm.clone.endDate.mode === mode,
                ghost: _vm.clone.endDate.mode !== mode,
                small: "",
              },
              on: {
                click: function () {
                  return _vm.changeMode(mode)
                },
              },
            },
            [_vm._v("\n                " + _vm._s(mode) + "\n            ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.clone.endDate.mode === "static"
        ? _c(
            "div",
            { key: _vm.clone.endDate.mode, staticClass: "d-flex gap-5" },
            [
              _c(
                "div",
                { staticClass: "editor-row customize-editor-minimize" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v(_vm._s(_vm.$t("auto.waitForDuration"))),
                  ]),
                  _vm._v(" "),
                  _c("TiptapEditor", {
                    key: "static",
                    attrs: {
                      placeholder: "Duration",
                      "show-attributes": true,
                      "automation-mode": "",
                    },
                    model: {
                      value: _vm.clone.endDate.static.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.endDate.static, "value", $$v)
                      },
                      expression: "clone.endDate.static.value",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "editor-row customize-editor-minimize" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v(_vm._s(_vm.$t("auto.waitForUnit"))),
                  ]),
                  _vm._v(" "),
                  _c("CustomPicker", {
                    attrs: {
                      items: _vm.units,
                      idKey: "id",
                      labelKey: "label",
                      title: "Select Duration",
                    },
                    model: {
                      value: _vm.clone.endDate.static.unit,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.endDate.static, "unit", $$v)
                      },
                      expression: "clone.endDate.static.unit",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _c("div", { staticClass: "d-flex gap-5" }, [
            _c(
              "div",
              { staticClass: "editor-row customize-editor-minimize" },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("auto.waitForPickAFutureDateIsodateTimestamp")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("TiptapEditor", {
                  key: "dynamic",
                  attrs: {
                    placeholder: "Timestamp",
                    "show-attributes": true,
                    "automation-mode": "",
                  },
                  model: {
                    value: _vm.clone.endDate.dynamic.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.endDate.dynamic, "value", $$v)
                    },
                    expression: "clone.endDate.dynamic.value",
                  },
                }),
              ],
              1
            ),
          ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.waitForMatchAll"))),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.match.all,
            callback: function ($$v) {
              _vm.$set(_vm.clone.match, "all", $$v)
            },
            expression: "clone.match.all",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.clone.match.all
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.waitForMatchMediaMessages"))),
            ]),
            _vm._v(" "),
            _c("a-switch", {
              model: {
                value: _vm.clone.match.matchMediaMessages,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.match, "matchMediaMessages", $$v)
                },
                expression: "clone.match.matchMediaMessages",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.clone.match.all
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.waitForMatchingMessages"))),
            ]),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { small: "", ghost: "" },
                on: {
                  click: function () {
                    return _vm.clone.match.messages.push("")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("auto.waitForAddMessage")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-column gap-5" },
              _vm._l(_vm.clone.match.messages, function (message, i) {
                return _c("TiptapEditor", {
                  key: i,
                  attrs: {
                    placeholder: "Matching Messages",
                    "show-attributes": true,
                    "automation-mode": "",
                  },
                  model: {
                    value: _vm.clone.match.messages[i],
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.match.messages, i, $$v)
                    },
                    expression: "clone.match.messages[i]",
                  },
                })
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.clone.match.all
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.waitForMatchingScoreThreshold"))),
            ]),
            _vm._v(" "),
            _c("a-input-number", {
              attrs: { min: 50, max: 100 },
              model: {
                value: _vm.clone.match.minScore,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.match, "minScore", $$v)
                },
                expression: "clone.match.minScore",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    [
      "web-message",
      "instagram-message",
      "messenger-message",
      "telegram-message",
    ].includes(_vm.clone.mode)
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.waitForContactId"))),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Contact ID",
                "show-attributes": true,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.contactId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "contactId", $$v)
                },
                expression: "clone.contactId",
              },
            }),
          ],
          1
        )
      : _vm.clone.mode === "email-message"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.waitForEmailFrom"))),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Email From",
                "show-attributes": true,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.email.from,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.email, "from", $$v)
                },
                expression: "clone.email.from",
              },
            }),
          ],
          1
        )
      : _vm.clone.mode === "whatsapp-message"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.waitForWhatsappNumber"))),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Whatsapp Number",
                "show-attributes": true,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.whatsappNumber,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "whatsappNumber", $$v)
                },
                expression: "clone.whatsappNumber",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }